import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Questions } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class QuestionsModule extends VuexModule {
    @Action
    [Questions.listQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/questions/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}